import React, { useEffect } from 'react';
import { IonPage } from '@ionic/react';

/**
 * Fallback for any path no top-level route matches (a stale bookmark, a
 * restored tab, a mistyped URL): sends the visitor home.
 *
 * IonRouterOutlet treats a <Route> without a `path` as its not-found route.
 * Without one, an unknown path renders nothing at all — a blank white page.
 *
 * Uses window.location.replace (hard navigation) rather than React Router
 * <Redirect>, for the same reason as LegRedirect: IonRouterOutlet can't
 * reliably animate a cross-route transition from a cold load. `replace` also
 * keeps the dead URL out of the back stack.
 */
const NotFoundRedirect: React.FC = () => {
  useEffect(() => {
    window.location.replace('/');
  }, []);

  return <IonPage />;
};

export default NotFoundRedirect;
